/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import '../../common/categories/categories_requests';
import '../../common/categories/categories_responses';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "dashboard": {
            "nested": {
              "categories": {
                "nested": {
                  "DashboardWebCategoriesService": {
                    "methods": {
                      "ListCategories": {
                        "requestType": ".squareup.bbfrontend.common.categories.ListCategoriesRequest",
                        "responseType": ".squareup.bbfrontend.common.categories.ListCategoriesResponse"
                      },
                      "UpdateCategory": {
                        "requestType": ".squareup.bbfrontend.common.categories.UpdateCategoryRequest",
                        "responseType": ".squareup.bbfrontend.common.categories.UpdateCategoryResponse"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.categories?.nested?.DashboardWebCategoriesService) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE DashboardWebCategoriesService @ squareup/bbfrontend/dashboardweb/categories/categories_service.proto at 13:1
 */
export const DashboardWebCategoriesService = $root.lookupService('squareup.bbfrontend.dashboard.categories.DashboardWebCategoriesService');